import React from 'react';
import { Link } from 'react-router-dom';

import BaseConfirmationScreen from '../BaseConfirmationScreen';

import './style.css';


const Component = () => (
  <BaseConfirmationScreen
    backTo="/login"
    backLabel="Log in"
    confirmationText="Password reset successfully"
    noBorder
  >
    <div styleName="pleaseLoginText">
      Please use your new password to&nbsp;
      <Link
        styleName="loginLink"
        to="/login"
      >
        Log in
      </Link>
      &nbsp;to My IPO
    </div>
  </BaseConfirmationScreen>
);

Component.displayName = 'ResetConfirmation';

export default Component;



// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetConfirmation.js